<template>
    <div class="row justify-content-center align-items-center" id="register">
        <div class="col-md-6 col-11">
            <card class="card-signup text-center" no-footer-line>
                <template slot="header">
                    <h4 class="card-title">Update Password</h4>
                </template>

                <fg-input
                    v-model="password.value"
                    placeholder="Password"
                    type="password"
                    @keyup.enter.native="submit()"/>
                
                <fg-input
                    v-model="password.confirmation"
                    placeholder="Password Confirmation"
                    type="password"
                    @keyup.enter.native="submit()"/>

                <div slot="footer">
                    <n-button
                        :loading="loading"
                        class="btn btn-primary btn-round btn-lg"
                        @click.native="submit()">
                            Reset
                    </n-button>
                </div>
            </card>
        </div>
    </div>
</template>

<script>
export default {
    data () {
        return {
            loading: false,
            password: {
                value: '',
                confirmation: ''
            }
        }
    },
    methods: {
        submit: async function () {
            if (this.password.value !== this.password.confirmation) {
                this.$notify({ type: 'danger', message: 'Invalid password confirmation!' })
                return
            }

            this.loading = true
            try {
                await this.$store.dispatch('newPassword', {
                    password: this.password.value,
                    code: this.$route.query.resetCode
                })

                this.$notify({ type: 'success', message: 'Password reset successfully please login' })
                this.$router.push({ name: 'login' })
            } catch (e) {
                console.log('error on updating password')
            }
            this.loading = false
        }
    }
}
</script>